import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  // tslint:disable:no-input-rename
  @HostBinding('class')
  @Input('class')
  classList = '';
}
